import { render } from "./EmptyComponent.vue?vue&type=template&id=04bf13aa&scoped=true"
const script = {}

import "./EmptyComponent.vue?vue&type=style&index=0&id=04bf13aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04bf13aa"]])

export default __exports__